import type { AIConfig } from '../../../types/ai';

// This configuration is now deprecated - AI configuration is handled via environment variables
// Keep this file for backwards compatibility, but it will be ignored
// Use the Settings page to configure AI preferences, API keys come from environment
export const aiConfig: AIConfig = {
  apiKey: '', // API keys now come from environment variables (OPENAI_API_KEY, ANTHROPIC_API_KEY, GROQ_API_KEY)
  provider: 'anthropic', // Default provider preference - can be changed in Settings
  model: 'claude-3-5-sonnet-20241022', // Default model preference
  enabled: true // Enable AI features by default
};

// Migration note: This file is kept for compatibility but is no longer used for API keys
// API keys are now configured via environment variables:
// - OPENAI_API_KEY for OpenAI
// - ANTHROPIC_API_KEY for Anthropic
// - GROQ_API_KEY for Groq
// - VITE_GODMODE_API_SECRET for authentication
// - VITE_HAS_OPENAI, VITE_HAS_ANTHROPIC, VITE_HAS_GROQ to indicate available providers